// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file credential_service.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { SessionType } from "./session_type_pb";
import { file_session_type } from "./session_type_pb";
import type { SyncUpdate } from "./sync_update_pb";
import { file_sync_update } from "./sync_update_pb";
import type { AuthenticatorType } from "./authenticator_type_pb";
import { file_authenticator_type } from "./authenticator_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file credential_service.proto.
 */
export const file_credential_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_session_type, file_sync_update, file_authenticator_type]);

/**
 * @generated from message domain.Token
 */
export type Token = Message<"domain.Token"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * used by clients to invalidate token
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message domain.Token.
 * Use `create(TokenSchema)` to create a new message.
 */
export const TokenSchema: GenMessage<Token> = /*@__PURE__*/
  messageDesc(file_credential_service, 0);

/**
 * Set exactly one field.
 *
 * @generated from message domain.CreateChallengeRequest
 */
export type CreateChallengeRequest = Message<"domain.CreateChallengeRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string backup_authenticator_id = 3;
   */
  backupAuthenticatorId: string;

  /**
   * @generated from field: string user_id = 4;
   */
  userId: string;
};

/**
 * Describes the message domain.CreateChallengeRequest.
 * Use `create(CreateChallengeRequestSchema)` to create a new message.
 */
export const CreateChallengeRequestSchema: GenMessage<CreateChallengeRequest> = /*@__PURE__*/
  messageDesc(file_credential_service, 1);

/**
 * @generated from message domain.CreateChallengeResponse
 */
export type CreateChallengeResponse = Message<"domain.CreateChallengeResponse"> & {
  /**
   * TODO: Token challenge = 1;
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string challenge = 2;
   */
  challenge: string;

  /**
   * @generated from field: repeated domain.CreateChallengeResponse.Authenticator authenticators = 3;
   */
  authenticators: CreateChallengeResponse_Authenticator[];
};

/**
 * Describes the message domain.CreateChallengeResponse.
 * Use `create(CreateChallengeResponseSchema)` to create a new message.
 */
export const CreateChallengeResponseSchema: GenMessage<CreateChallengeResponse> = /*@__PURE__*/
  messageDesc(file_credential_service, 2);

/**
 * @generated from message domain.CreateChallengeResponse.Authenticator
 */
export type CreateChallengeResponse_Authenticator = Message<"domain.CreateChallengeResponse.Authenticator"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: domain.AuthenticatorType authenticator_type = 4;
   */
  authenticatorType: AuthenticatorType;

  /**
   * @generated from field: string secret_info = 3;
   */
  secretInfo: string;

  /**
   * @generated from field: domain.CreateChallengeResponse.Authenticator.Webauthn webauthn = 5;
   */
  webauthn?: CreateChallengeResponse_Authenticator_Webauthn | undefined;
};

/**
 * Describes the message domain.CreateChallengeResponse.Authenticator.
 * Use `create(CreateChallengeResponse_AuthenticatorSchema)` to create a new message.
 */
export const CreateChallengeResponse_AuthenticatorSchema: GenMessage<CreateChallengeResponse_Authenticator> = /*@__PURE__*/
  messageDesc(file_credential_service, 2, 0);

/**
 * @generated from message domain.CreateChallengeResponse.Authenticator.Webauthn
 */
export type CreateChallengeResponse_Authenticator_Webauthn = Message<"domain.CreateChallengeResponse.Authenticator.Webauthn"> & {
  /**
   * @generated from field: string webauthn_id = 1;
   */
  webauthnId: string;

  /**
   * @generated from field: bytes prf_salt = 2;
   */
  prfSalt: Uint8Array;
};

/**
 * Describes the message domain.CreateChallengeResponse.Authenticator.Webauthn.
 * Use `create(CreateChallengeResponse_Authenticator_WebauthnSchema)` to create a new message.
 */
export const CreateChallengeResponse_Authenticator_WebauthnSchema: GenMessage<CreateChallengeResponse_Authenticator_Webauthn> = /*@__PURE__*/
  messageDesc(file_credential_service, 2, 0, 0);

/**
 * @generated from message domain.CreateLongPollChannelChallengeRequest
 */
export type CreateLongPollChannelChallengeRequest = Message<"domain.CreateLongPollChannelChallengeRequest"> & {
  /**
   * @generated from field: string public_key_hash = 1;
   */
  publicKeyHash: string;
};

/**
 * Describes the message domain.CreateLongPollChannelChallengeRequest.
 * Use `create(CreateLongPollChannelChallengeRequestSchema)` to create a new message.
 */
export const CreateLongPollChannelChallengeRequestSchema: GenMessage<CreateLongPollChannelChallengeRequest> = /*@__PURE__*/
  messageDesc(file_credential_service, 3);

/**
 * @generated from message domain.CreateLongPollChannelChallengeResponse
 */
export type CreateLongPollChannelChallengeResponse = Message<"domain.CreateLongPollChannelChallengeResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string challenge = 2;
   */
  challenge: string;

  /**
   * @generated from field: domain.CreateLongPollChannelChallengeResponse.Authenticator authenticator = 3;
   */
  authenticator?: CreateLongPollChannelChallengeResponse_Authenticator | undefined;

  /**
   * @generated from field: bytes authenticator_reply = 4;
   */
  authenticatorReply: Uint8Array;
};

/**
 * Describes the message domain.CreateLongPollChannelChallengeResponse.
 * Use `create(CreateLongPollChannelChallengeResponseSchema)` to create a new message.
 */
export const CreateLongPollChannelChallengeResponseSchema: GenMessage<CreateLongPollChannelChallengeResponse> = /*@__PURE__*/
  messageDesc(file_credential_service, 4);

/**
 * @generated from message domain.CreateLongPollChannelChallengeResponse.Authenticator
 */
export type CreateLongPollChannelChallengeResponse_Authenticator = Message<"domain.CreateLongPollChannelChallengeResponse.Authenticator"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: domain.AuthenticatorType authenticator_type = 4;
   */
  authenticatorType: AuthenticatorType;

  /**
   * @generated from field: string secret_info = 3;
   */
  secretInfo: string;
};

/**
 * Describes the message domain.CreateLongPollChannelChallengeResponse.Authenticator.
 * Use `create(CreateLongPollChannelChallengeResponse_AuthenticatorSchema)` to create a new message.
 */
export const CreateLongPollChannelChallengeResponse_AuthenticatorSchema: GenMessage<CreateLongPollChannelChallengeResponse_Authenticator> = /*@__PURE__*/
  messageDesc(file_credential_service, 4, 0);

/**
 * @generated from message domain.CompleteLongPollChannelRequest
 */
export type CompleteLongPollChannelRequest = Message<"domain.CompleteLongPollChannelRequest"> & {
  /**
   * @generated from field: string public_key_hash = 1;
   */
  publicKeyHash: string;

  /**
   * @generated from field: string authenticator_id = 2;
   */
  authenticatorId: string;

  /**
   * @generated from field: bytes authenticator_reply = 3;
   */
  authenticatorReply: Uint8Array;
};

/**
 * Describes the message domain.CompleteLongPollChannelRequest.
 * Use `create(CompleteLongPollChannelRequestSchema)` to create a new message.
 */
export const CompleteLongPollChannelRequestSchema: GenMessage<CompleteLongPollChannelRequest> = /*@__PURE__*/
  messageDesc(file_credential_service, 5);

/**
 * @generated from message domain.CompleteLongPollChannelResponse
 */
export type CompleteLongPollChannelResponse = Message<"domain.CompleteLongPollChannelResponse"> & {
};

/**
 * Describes the message domain.CompleteLongPollChannelResponse.
 * Use `create(CompleteLongPollChannelResponseSchema)` to create a new message.
 */
export const CompleteLongPollChannelResponseSchema: GenMessage<CompleteLongPollChannelResponse> = /*@__PURE__*/
  messageDesc(file_credential_service, 6);

/**
 * @generated from message domain.CreateTokensRequest
 */
export type CreateTokensRequest = Message<"domain.CreateTokensRequest"> & {
  /**
   * @generated from field: string authenticator_id = 2;
   */
  authenticatorId: string;

  /**
   * @generated from field: string challenge = 3;
   */
  challenge: string;

  /**
   * @generated from field: bytes response = 4;
   */
  response: Uint8Array;

  /**
   * @generated from field: domain.CreateTokensRequest.SessionUnlock session_unlock = 5;
   */
  sessionUnlock?: CreateTokensRequest_SessionUnlock | undefined;

  /**
   * @generated from field: domain.SessionType session_type = 6;
   */
  sessionType: SessionType;

  /**
   * Read from device management by connected clients, see organizations.browser_managed_device_token.
   *
   * @generated from field: string browser_managed_device_token = 7;
   */
  browserManagedDeviceToken: string;
};

/**
 * Describes the message domain.CreateTokensRequest.
 * Use `create(CreateTokensRequestSchema)` to create a new message.
 */
export const CreateTokensRequestSchema: GenMessage<CreateTokensRequest> = /*@__PURE__*/
  messageDesc(file_credential_service, 7);

/**
 * @generated from message domain.CreateTokensRequest.SessionUnlock
 */
export type CreateTokensRequest_SessionUnlock = Message<"domain.CreateTokensRequest.SessionUnlock"> & {
  /**
   * @generated from field: bytes encrypted_secret = 1;
   */
  encryptedSecret: Uint8Array;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * @generated from field: bool single_use = 5;
   */
  singleUse: boolean;
};

/**
 * Describes the message domain.CreateTokensRequest.SessionUnlock.
 * Use `create(CreateTokensRequest_SessionUnlockSchema)` to create a new message.
 */
export const CreateTokensRequest_SessionUnlockSchema: GenMessage<CreateTokensRequest_SessionUnlock> = /*@__PURE__*/
  messageDesc(file_credential_service, 7, 0);

/**
 * @generated from message domain.CreateTokensResponse
 */
export type CreateTokensResponse = Message<"domain.CreateTokensResponse"> & {
  /**
   * @generated from field: domain.Token access_token = 1;
   */
  accessToken?: Token | undefined;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: domain.SyncUpdate sync_update = 4;
   */
  syncUpdate?: SyncUpdate | undefined;

  /**
   * @generated from field: int32 token_version = 5;
   */
  tokenVersion: number;
};

/**
 * Describes the message domain.CreateTokensResponse.
 * Use `create(CreateTokensResponseSchema)` to create a new message.
 */
export const CreateTokensResponseSchema: GenMessage<CreateTokensResponse> = /*@__PURE__*/
  messageDesc(file_credential_service, 8);

/**
 * @generated from message domain.CreateAuditlogWriteTokenRequest
 */
export type CreateAuditlogWriteTokenRequest = Message<"domain.CreateAuditlogWriteTokenRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message domain.CreateAuditlogWriteTokenRequest.
 * Use `create(CreateAuditlogWriteTokenRequestSchema)` to create a new message.
 */
export const CreateAuditlogWriteTokenRequestSchema: GenMessage<CreateAuditlogWriteTokenRequest> = /*@__PURE__*/
  messageDesc(file_credential_service, 9);

/**
 * @generated from message domain.CreateAuditlogWriteTokenResponse
 */
export type CreateAuditlogWriteTokenResponse = Message<"domain.CreateAuditlogWriteTokenResponse"> & {
  /**
   * @generated from field: domain.Token token = 1;
   */
  token?: Token | undefined;
};

/**
 * Describes the message domain.CreateAuditlogWriteTokenResponse.
 * Use `create(CreateAuditlogWriteTokenResponseSchema)` to create a new message.
 */
export const CreateAuditlogWriteTokenResponseSchema: GenMessage<CreateAuditlogWriteTokenResponse> = /*@__PURE__*/
  messageDesc(file_credential_service, 10);

/**
 * @generated from message domain.CreateAuditlogAdminTokenRequest
 */
export type CreateAuditlogAdminTokenRequest = Message<"domain.CreateAuditlogAdminTokenRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message domain.CreateAuditlogAdminTokenRequest.
 * Use `create(CreateAuditlogAdminTokenRequestSchema)` to create a new message.
 */
export const CreateAuditlogAdminTokenRequestSchema: GenMessage<CreateAuditlogAdminTokenRequest> = /*@__PURE__*/
  messageDesc(file_credential_service, 11);

/**
 * @generated from message domain.CreateAuditlogAdminTokenResponse
 */
export type CreateAuditlogAdminTokenResponse = Message<"domain.CreateAuditlogAdminTokenResponse"> & {
  /**
   * @generated from field: domain.Token token = 1;
   */
  token?: Token | undefined;
};

/**
 * Describes the message domain.CreateAuditlogAdminTokenResponse.
 * Use `create(CreateAuditlogAdminTokenResponseSchema)` to create a new message.
 */
export const CreateAuditlogAdminTokenResponseSchema: GenMessage<CreateAuditlogAdminTokenResponse> = /*@__PURE__*/
  messageDesc(file_credential_service, 12);

/**
 * @generated from message domain.CreateLFDOverridesAdminTokenRequest
 */
export type CreateLFDOverridesAdminTokenRequest = Message<"domain.CreateLFDOverridesAdminTokenRequest"> & {
};

/**
 * Describes the message domain.CreateLFDOverridesAdminTokenRequest.
 * Use `create(CreateLFDOverridesAdminTokenRequestSchema)` to create a new message.
 */
export const CreateLFDOverridesAdminTokenRequestSchema: GenMessage<CreateLFDOverridesAdminTokenRequest> = /*@__PURE__*/
  messageDesc(file_credential_service, 13);

/**
 * @generated from message domain.CreateLFDOverridesAdminTokenResponse
 */
export type CreateLFDOverridesAdminTokenResponse = Message<"domain.CreateLFDOverridesAdminTokenResponse"> & {
  /**
   * @generated from field: domain.Token token = 1;
   */
  token?: Token | undefined;
};

/**
 * Describes the message domain.CreateLFDOverridesAdminTokenResponse.
 * Use `create(CreateLFDOverridesAdminTokenResponseSchema)` to create a new message.
 */
export const CreateLFDOverridesAdminTokenResponseSchema: GenMessage<CreateLFDOverridesAdminTokenResponse> = /*@__PURE__*/
  messageDesc(file_credential_service, 14);

/**
 * @generated from message domain.CreateSyncTokenRequest
 */
export type CreateSyncTokenRequest = Message<"domain.CreateSyncTokenRequest"> & {
};

/**
 * Describes the message domain.CreateSyncTokenRequest.
 * Use `create(CreateSyncTokenRequestSchema)` to create a new message.
 */
export const CreateSyncTokenRequestSchema: GenMessage<CreateSyncTokenRequest> = /*@__PURE__*/
  messageDesc(file_credential_service, 15);

/**
 * @generated from message domain.CreateSyncTokenResponse
 */
export type CreateSyncTokenResponse = Message<"domain.CreateSyncTokenResponse"> & {
  /**
   * @generated from field: domain.Token token = 1;
   */
  token?: Token | undefined;
};

/**
 * Describes the message domain.CreateSyncTokenResponse.
 * Use `create(CreateSyncTokenResponseSchema)` to create a new message.
 */
export const CreateSyncTokenResponseSchema: GenMessage<CreateSyncTokenResponse> = /*@__PURE__*/
  messageDesc(file_credential_service, 16);

/**
 * @generated from message domain.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"domain.RefreshTokenRequest"> & {
};

/**
 * Describes the message domain.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> = /*@__PURE__*/
  messageDesc(file_credential_service, 17);

/**
 * @generated from message domain.RefreshTokenResponse
 */
export type RefreshTokenResponse = Message<"domain.RefreshTokenResponse"> & {
  /**
   * @generated from field: domain.Token new_access_token = 1;
   */
  newAccessToken?: Token | undefined;

  /**
   * @generated from field: int32 token_version = 2;
   */
  tokenVersion: number;
};

/**
 * Describes the message domain.RefreshTokenResponse.
 * Use `create(RefreshTokenResponseSchema)` to create a new message.
 */
export const RefreshTokenResponseSchema: GenMessage<RefreshTokenResponse> = /*@__PURE__*/
  messageDesc(file_credential_service, 18);

/**
 * CredentialService provides methods to create authentication tokens and manage open sessions.
 * Typical usage:
 * (1) Client calls CreateChallenge to obtain challenge.
 * (2) Client obtains authenticator secret and signs the challenge.
 *     For push authenticators the AuthenticatorService might be used
 *     to create a comm channel between authenticator and client.
 * (3) Client calls CreateTokens with the signed challenge (response) to obtain
 *     an access tokens.
 * (4) Clients sends token in further requests to authenticate.
 *
 * @generated from service domain.CredentialService
 */
export const CredentialService: GenService<{
  /**
   * errors:
   * - UserNotFound (20400): email does not belong to a user
   * - AuthenticatorNotFound (40400): backup authenticator was not found
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.CredentialService.CreateChallenge
   */
  createChallenge: {
    methodKind: "unary";
    input: typeof CreateChallengeRequestSchema;
    output: typeof CreateChallengeResponseSchema;
  },
  /**
   * errors:
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.CredentialService.CreateLongPollChannelChallenge
   */
  createLongPollChannelChallenge: {
    methodKind: "unary";
    input: typeof CreateLongPollChannelChallengeRequestSchema;
    output: typeof CreateLongPollChannelChallengeResponseSchema;
  },
  /**
   * errors:
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.CredentialService.CompleteLongPollChannel
   */
  completeLongPollChannel: {
    methodKind: "unary";
    input: typeof CompleteLongPollChannelRequestSchema;
    output: typeof CompleteLongPollChannelResponseSchema;
  },
  /**
   * errors:
   * - InvalidTimeout (20420): expires_at of given session_unlock ist already expired
   * - AuthenticatorNotFound (40400): invalid combination of user_id and authenticator_id
   * - InvalidChallenge (30410): invalid challenge
   * - InvalidSignature (30400): invalid response fo the hcallenge
   * - BrowserManagedDeviceTokenInvalid (30470): organization restricts logins to managed devices
   * - Internal (10500): internal server error
   *
   * @generated from rpc domain.CredentialService.CreateTokens
   */
  createTokens: {
    methodKind: "unary";
    input: typeof CreateTokensRequestSchema;
    output: typeof CreateTokensResponseSchema;
  },
  /**
   * - MissingCredentials (30100)
   * - OrganizationNotFound (60400): not member of the given organization, or auditlog not enabled
   * - Internal (10500)
   *
   * @generated from rpc domain.CredentialService.CreateAuditlogWriteToken
   */
  createAuditlogWriteToken: {
    methodKind: "unary";
    input: typeof CreateAuditlogWriteTokenRequestSchema;
    output: typeof CreateAuditlogWriteTokenResponseSchema;
  },
  /**
   * - MissingCredentials (30100)
   * - OrganizationNotFound (60400): not member of the given organization, or auditlog not enabled
   * - OrganizationInsufficientAccess (60100)
   * - Internal (10500)
   *
   * @generated from rpc domain.CredentialService.CreateAuditlogAdminToken
   */
  createAuditlogAdminToken: {
    methodKind: "unary";
    input: typeof CreateAuditlogAdminTokenRequestSchema;
    output: typeof CreateAuditlogAdminTokenResponseSchema;
  },
  /**
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - PermissionDenied (10100)
   * - Internal (10500)
   *
   * @generated from rpc domain.CredentialService.CreateLFDOverridesAdminToken
   */
  createLFDOverridesAdminToken: {
    methodKind: "unary";
    input: typeof CreateLFDOverridesAdminTokenRequestSchema;
    output: typeof CreateLFDOverridesAdminTokenResponseSchema;
  },
  /**
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420)
   * - Internal (10500)
   *
   * @generated from rpc domain.CredentialService.CreateSyncToken
   */
  createSyncToken: {
    methodKind: "unary";
    input: typeof CreateSyncTokenRequestSchema;
    output: typeof CreateSyncTokenResponseSchema;
  },
  /**
   * - MissingCredentials (30100)
   * - InvalidCredentials (30420): the credentials provided are invalid (e.g. session was deleted)
   * - Internal (10500)
   *
   * @generated from rpc domain.CredentialService.RefreshToken
   */
  refreshToken: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof RefreshTokenResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_credential_service, 0);

